var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLoginGoogleLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5006 36.3072C49.5017 35.381 49.4179 34.4565 49.2501 33.5449H36.2725V38.7669H43.6866C43.5327 39.592 43.2098 40.378 42.7374 41.0775C42.265 41.777 41.6528 42.3754 40.9379 42.8366V46.2246H45.3893C47.9939 43.8744 49.4967 40.4126 49.4967 36.3047L49.5006 36.3072Z",
    fill: "#3E82F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2759 49.4973C39.9953 49.4973 43.1139 48.2891 45.3927 46.2275L40.9414 42.8395C39.7072 43.6496 38.1291 44.1291 36.2759 44.1291C32.6876 44.1291 29.6508 41.7534 28.5685 38.5625H23.9653V42.0612C25.112 44.2973 26.8706 46.177 29.0445 47.4901C31.2185 48.8033 33.7222 49.4982 36.2759 49.4973Z",
    fill: "#32A753"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5685 38.5633C27.9923 36.9003 27.9923 35.0973 28.5685 33.4342V29.9355H23.9653C23.0019 31.8173 22.5002 33.8935 22.5002 35.9988C22.5002 38.1041 23.0019 40.1803 23.9653 42.062L28.5685 38.5633Z",
    fill: "#F9BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2758 27.8682C38.299 27.8682 40.1146 28.5499 41.5421 29.8878L45.4925 26.0152C43.1072 23.8366 39.9887 22.5 36.2784 22.5C33.7246 22.4991 31.2209 23.194 29.047 24.5072C26.873 25.8203 25.1145 27.7 23.9678 29.9361L28.5709 33.4348C29.6533 30.2439 32.6901 27.8682 36.2784 27.8682H36.2758Z",
    fill: "#E74133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(22.5 22.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLoginGoogleLarge);
export default __webpack_public_path__ + "static/media/img_login_google_large.005e3c0d45ede415dc2307bf9b09a531.svg";
export { ForwardRef as ReactComponent };